import { ref } from 'vue';


// The redirect url is stored globally, so we do not need to pass it through all functions.
// It is a vue reative reference.
export const redirectUrl = ref();

/**
 * Reloads the browser window.
 * This function was introduced with the sentry debugging in order to only have one place where a reload could happen.
 *
 * @param {String} url - A given redirect url.
 */
export function reloadBrowserWindow(url = null) {
  if (url) {
    window.location.assign(url);

    return;
  }

  window.location.reload();
}

export const sessionStoreInitialData = window?.initialData?.session || {};
export const currentUser = sessionStoreInitialData?.user || {};
export const isUserLoggedIn = currentUser?.uid;
export const isInternalUser = currentUser?.internal;
export const isLoginEnabled = sessionStoreInitialData?.isLoginEnabled || false;
